<template>
  <div class="divide-y divide-[var(--color-stroke)]">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { provide, ref, toRef } from 'vue';
import { ACCORDION_KEY } from '@/components/feedback/accordion-context';

interface Props {
  multiple?: boolean;
  defaultOpen?: readonly string[];
}

const props = withDefaults(defineProps<Props>(), {
  multiple: false,
  defaultOpen: () => [],
});

const emit = defineEmits<{
  (e: 'change', openIds: readonly string[]): void;
}>();

const openIds = ref<string[]>([...props.defaultOpen]);

function toggle(id: string): void {
  const has = openIds.value.includes(id);
  if (props.multiple) {
    openIds.value = has ? openIds.value.filter((x) => x !== id) : [...openIds.value, id];
  } else {
    openIds.value = has ? [] : [id];
  }
  emit('change', openIds.value);
}

function isOpen(id: string): boolean {
  return openIds.value.includes(id);
}

provide(ACCORDION_KEY, {
  multiple: toRef(props, 'multiple'),
  isOpen,
  toggle,
});
</script>
